/* SurveyForm.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./SurveyForm.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useCallback, useRef, useState } from 'react';
import { Transition } from 'react-transition-group';
import Button from '@atlaskit/button/new';
import { Checkbox } from '@atlaskit/checkbox';
import Form, { CheckboxField, Field, FormFooter } from '@atlaskit/form';
import Heading from '@atlaskit/heading';
import { Stack, Text } from '@atlaskit/primitives/compiled';
import Textarea from '@atlaskit/textarea';
import FeedbackScoreButtons from './FeedbackScoreButtons';
var transitionBaseStyles = null;
var getExpandedHeight = function getExpandedHeight(ref, state) {
  if (!ref.current) {
    return '0';
  }
  switch (state) {
    case 'entering':
      return "".concat(ref.current.scrollHeight, "px");
    case 'entered':
      // needed for TextField auto height expand
      return "none";
    default:
      return '0';
  }
};
var transitionDuration = 200;
export default (function (_ref) {
  var question = _ref.question,
    statement = _ref.statement,
    textPlaceholder = _ref.textPlaceholder,
    textLabel = _ref.textLabel,
    onSubmit = _ref.onSubmit;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    canContactDefault = _useState4[0],
    setCanContactDefault = _useState4[1];
  var hasAutoFilledCanContactRef = useRef(false);
  var expandedAreaRef = useRef(null);
  var onScoreSelect = useCallback(function () {
    setExpanded(true);
  }, [setExpanded]);

  // On the first type the user types some feedback we auto select
  // the option for allowing feedback. This automatic selection only
  // happens once. After that it is up to the user to control
  var onFeedbackChange = useCallback(function () {
    if (hasAutoFilledCanContactRef.current) {
      return;
    }
    hasAutoFilledCanContactRef.current = true;
    setCanContactDefault(true);
  }, []);
  return /*#__PURE__*/React.createElement("section", {
    "aria-labelledby": "contextualSurveyQuestion"
  }, /*#__PURE__*/React.createElement(Stack, {
    space: "space.150"
  }, /*#__PURE__*/React.createElement(Heading, {
    id: "contextualSurveyQuestion",
    size: "xsmall",
    as: "h2"
  }, question), statement && /*#__PURE__*/React.createElement(Text, {
    as: "p",
    id: "contextualSurveyStatement"
  }, statement)), /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, function (_ref2) {
    var formProps = _ref2.formProps,
      submitting = _ref2.submitting;
    return /*#__PURE__*/React.createElement("form", formProps, /*#__PURE__*/React.createElement(Field, {
      name: "feedbackScore",
      isDisabled: submitting,
      isRequired: true
    }, function (_ref3) {
      var fieldProps = _ref3.fieldProps;
      return /*#__PURE__*/React.createElement(FeedbackScoreButtons, _extends({}, fieldProps, {
        onChange: function onChange(score) {
          fieldProps.onChange(score);
          onScoreSelect();
        }
      }));
    }), /*#__PURE__*/React.createElement(Transition, {
      in: expanded,
      timeout: transitionDuration,
      mountOnEnter: true
    }, function (state) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          transition: "max-height ".concat(transitionDuration, "ms ease-in-out"),
          maxHeight: getExpandedHeight(expandedAreaRef, state)
        },
        ref: expandedAreaRef,
        className: ax(["_1reo15vq _18m915vq"])
      }, /*#__PURE__*/React.createElement(Field, {
        name: "writtenFeedback",
        defaultValue: "",
        isDisabled: submitting
      }, function (_ref4) {
        var fieldProps = _ref4.fieldProps;
        return /*#__PURE__*/React.createElement(Textarea, _extends({}, fieldProps, {
          "aria-label": textLabel,
          placeholder: textPlaceholder,
          onChange: function onChange(event) {
            fieldProps.onChange(event);
            onFeedbackChange();
          }
        }));
      }), /*#__PURE__*/React.createElement(CheckboxField, {
        name: "canContact",
        isDisabled: submitting,
        defaultIsChecked: canContactDefault
      }, function (_ref5) {
        var fieldProps = _ref5.fieldProps;
        return /*#__PURE__*/React.createElement(Checkbox, _extends({}, fieldProps, {
          label: "Atlassian can contact me about this feedback"
        }));
      }), /*#__PURE__*/React.createElement(FormFooter, null, /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        appearance: "primary",
        isLoading: submitting
      }, "Submit")));
    }));
  }));
});